import {useEffect,useState} from 'preact/hooks';
import {useClient} from '@/ui/context';
import {Button} from '@/ui/components';
import {UI_ITEM_BG,UI_PANEL_BORDER} from '@/ui/consts';
import {getMercenary,sendMercenary,subscribeMercenary,type MercenaryRole} from '@/mercenaries';
import {DialogBase} from './dialog-base';
import {useWindowManager} from '@/ui/in-game';

const descriptions:Record<MercenaryRole,string>={
 archer:'Keeps enemies at bow range and covers your approach.',
 healer:'Restores your health while you lead the fight.',
 tank:'Draws enemy attention and holds the front line.',
 caster:'Strikes from a distance with combat magic.',
 warrior:'Fights beside you with close-range attacks.',
};
export function MercenaryDialog(){
 const c=useClient();const {closeDialog}=useWindowManager();const [,redraw]=useState(0);const [now,setNow]=useState(Date.now());
 useEffect(()=>{closeDialog('guild');const off=subscribeMercenary(c,()=>redraw(n=>n+1));sendMercenary(c,'mercenary_view');let map=c.mapId;
  const timer=window.setInterval(()=>{setNow(Date.now());if(!c.worldLoading&&map!==c.mapId){closeDialog('mercenary');}},1000);
  return ()=>{off();clearInterval(timer);};},[c]);
 const {snapshot:s,pending}=getMercenary(c),hire=s?.hire;
 const active=hire&&['pending','active'].includes(hire.state)&&hire.expires_at*1000>now;
 const hireRole=(role:MercenaryRole)=>c.alertController.showConfirm('Hire a mercenary?',`Hire a ${role} for ${s?.price.toLocaleString()} gold for one hour? Your hire expires one hour after purchase, including time offline.`,confirmed=>{if(confirmed)sendMercenary(c,'mercenary_hire',role);});
 return <DialogBase id='mercenary' title='Merc Mac' size='lg' touchScroll>
  <div class='flex flex-col gap-3 p-3 text-sm' data-mercenary-panel>
   {!s?<p role='status'>{pending?'Finding your mercenary…':'No response yet.'}</p>:<>
    {active?<section class={`rounded border ${UI_PANEL_BORDER} ${UI_ITEM_BG} p-3`}>
     <h3 class='font-bold capitalize'>{hire.role}</h3>
     <p>{Math.ceil((hire.expires_at*1000-now)/60000)} minutes remaining{hire.state==='pending'?' · Preparing your hire…':''}</p>
     <div class='mt-3 flex flex-wrap gap-2'>
      <Button variant={['sm']} disabled={pending||hire.state!=='active'} onClick={()=>sendMercenary(c,'mercenary_follow')}>Follow</Button>
      <Button variant={['sm']} disabled={pending||hire.state!=='active'} onClick={()=>sendMercenary(c,'mercenary_fight')}>Fight</Button>
      {hire.role==='tank'&&<Button variant={['sm']} disabled={pending||hire.state!=='active'} onClick={()=>sendMercenary(c,'mercenary_tank')}>Tank</Button>}
      {hire.role==='healer'&&<Button variant={['sm']} disabled={pending||hire.state!=='active'} onClick={()=>sendMercenary(c,'mercenary_heal')}>Heal me</Button>}
      <Button variant={['sm']} disabled={pending} onClick={()=>c.alertController.showConfirm('Dismiss your mercenary?','This ends your hire. Unused time is not refunded.',confirmed=>{if(confirmed)sendMercenary(c,'mercenary_dismiss');})}>Dismiss</Button>
     </div>
    </section>:<>
     <p>Merc Mac: “Need a hand? I know five people with excellent weapons and questionable pension plans. No refunds for heroic speeches.”</p>
     <p>{s.price.toLocaleString()} gold per hour · One mercenary at a time.</p>
     {s.recruiter_index===null&&<p>Speak to Merc Mac at the Aeven Guild Office to hire an ally.</p>}
     {!s.enabled&&<p>Recruitment is currently unavailable.</p>}
     {s.roles.map(r=><section key={r.role} class={`rounded border ${UI_PANEL_BORDER} ${UI_ITEM_BG} p-3`}>
      <h3 class='font-bold'>{r.name}</h3><p class='mt-1'>{descriptions[r.role]}</p>
      <Button variant={['sm']} disabled={pending||!s.enabled||s.recruiter_index===null} onClick={()=>hireRole(r.role)}>Hire {r.name}</Button>
     </section>)}
    </>}
    {s.message&&<p role='status'>{s.message}</p>}
   </>}
   <Button variant={['sm']} disabled={pending} onClick={()=>sendMercenary(c,'mercenary_view')}>Refresh</Button>
  </div>
 </DialogBase>;
}
